export default __webpack_public_path__ + "static/media/Snd_LowerWSlidedowna.a96d33fb.mp3";